import { defineComponent, ref, onMounted, onUnmounted, computed } from 'vue';
export default defineComponent({
  name: 'UpdateDialog',
  setup: function setup() {
    var visible = ref(false);
    var status = ref('');
    var version = ref('');
    var progressPercent = ref(0);
    var errorMessage = ref('');
    var closable = computed(function () {
      return status.value !== 'progress';
    });
    var showProgress = computed(function () {
      return status.value === 'progress';
    });
    var showDownloadBtn = computed(function () {
      return status.value === 'available';
    });
    var showLaterBtn = computed(function () {
      return status.value === 'available';
    });
    var showRestartBtn = computed(function () {
      return status.value === 'downloaded';
    });
    var showManualBtn = computed(function () {
      return status.value === 'error' || status.value === 'not-available';
    });
    var title = computed(function () {
      switch (status.value) {
        case 'checking':
          return '正在检查更新...';
        case 'available':
          return "\u53D1\u73B0\u65B0\u7248\u672C v".concat(version.value);
        case 'progress':
          return '正在下载更新...';
        case 'downloaded':
          return '更新已就绪';
        case 'not-available':
          return '已是最新版本';
        case 'error':
          return '更新检查失败';
        default:
          return '检查更新';
      }
    });
    var description = computed(function () {
      switch (status.value) {
        case 'checking':
          return '正在连接更新服务器，请稍候...';
        case 'available':
          return '检测到新版本，建议立即更新以获得最新功能和修复';
        case 'progress':
          return '下载完成后将自动提示安装';
        case 'downloaded':
          return '更新包已下载完成，重启应用后生效';
        case 'not-available':
          return '当前已是最新版本，无需更新';
        case 'error':
          return errorMessage.value || '无法检查更新，请稍后重试';
        default:
          return '';
      }
    });
    var isElectron = !!window.electronAPI;
    var electronAPI = isElectron ? window.electronAPI : null;
    function closeDialog() {
      visible.value = false;
    }
    function startDownload() {
      if (electronAPI) {
        electronAPI.downloadUpdate();
      }
    }
    function restartApp() {
      if (electronAPI) {
        electronAPI.quitAndInstall();
      }
    }
    if (isElectron && electronAPI) {
      electronAPI.onUpdateStatus(function (event) {
        switch (event.type) {
          case 'checking':
            visible.value = true;
            status.value = 'checking';
            break;
          case 'available':
            version.value = event.version || '';
            status.value = 'available';
            break;
          case 'progress':
            progressPercent.value = event.percent || 0;
            status.value = 'progress';
            break;
          case 'downloaded':
            status.value = 'downloaded';
            break;
          case 'not-available':
            status.value = 'not-available';
            break;
          case 'error':
            errorMessage.value = event.message || '更新检查失败';
            status.value = 'error';
            break;
        }
      });
    }
    onMounted(function () {
      if (isElectron && electronAPI) {
        electronAPI.checkForUpdate();
      }
    });
    onUnmounted(function () {
      if (isElectron && electronAPI) {
        electronAPI.removeUpdateStatus();
      }
    });
    return {
      visible: visible,
      title: title,
      description: description,
      closable: closable,
      showProgress: showProgress,
      showDownloadBtn: showDownloadBtn,
      showLaterBtn: showLaterBtn,
      showRestartBtn: showRestartBtn,
      showManualBtn: showManualBtn,
      progressPercent: progressPercent,
      closeDialog: closeDialog,
      startDownload: startDownload,
      restartApp: restartApp
    };
  }
});